export default __webpack_public_path__ + "static/media/verification.e5626a09.svg";